import React from "react";
import PropTypes from "prop-types";
import { parse } from "qs";

import { STREAM_TYPE } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import SearchStreamHeader from "stream/components/SearchStreamHeader";
import SummaryCard from "cards/containers/SummaryCard";
import NoResults from "stream/components/NoResults";

const SearchStream = ({ location }) => {
  const search = parse(location.search.slice(1)).q;

  return (
    <>
      <SearchStreamHeader searchTerm={search} />
      <StandardLayout
        main={
          <Stream
            type={STREAM_TYPE.SEARCH}
            lookup={search}
            onlyShowTitleForA11y={true}
            contentComponent={SummaryCard}
            noResultsComponent={<NoResults lookup={search} />}
            disableAnalytics={true}
            disableUrlUpdating={true}
          />
        }
        mainAriaLabel="Stories"
      />
    </>
  );
};

SearchStream.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default SearchStream;
